/* This example requires Tailwind CSS v2.0+ */
import { Fragment } from "react";
import { Disclosure, Menu, Transition } from "@headlessui/react";
import { BellIcon, MenuIcon, XIcon } from "@heroicons/react/outline";
import { useNavigate } from "react-router-dom";

const navigation = [
  { name: "Home", href: "", current: false ,path:'/' },
  { name: "About us", href: "", current: false.valueOf, path:'#AboutUS'},
  { name: "Contact us", href: "", current: false ,path:'#ContactUS'},
  { name: "Login", href: "", current: false,path:'/Login' },
  { name: "SignUp", href: "", current: false,path:'/Signup' },
  { name: "Dashboard", href: "", current: false,path:   
  
  localStorage.getItem('user_uid') !== null ?
  '/Dashboard': 
   localStorage.getItem('teacher_uid') !== null
  ?  '/TeacherDashboard'
  :
  'Login'
 },


];


function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Navbar(Props) {
  return (
    <Disclosure as="nav"  className={"mainBar"}>
      {({ open }) => (
        <>
        {console.log(">>>>>>>>>>:::",localStorage.getItem('teacher_uid'))}
          <div  className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
            <div className="relative flex items-center justify-between h-16">
              <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                {/* Mobile menu button*/}
                <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
              <img
                    className="hidden lg:block h-8 w-auto"
                    style={{width:'100%',height:'90px',paddingBottom:'1px'}}
                    src={require('../src/image/newLogo.png')}

                  />
                <div className="hidden sm:block sm:ml-6">
                  <div className="flex space-x-10">
                    {navigation.map((item) => (
                      <a
                      data-aos="flip-up"
                      data-aos-duration="800"
                        key={item.name}
                        href={item.path}
                        className={'fontShow'}
                        aria-current={item.current ? "page" : undefined}
                      >
                        {item.name}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
           
            </div>
          </div>

          <Disclosure.Panel className="sm:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1">
             

              {navigation.map((item) => (
                <>
                 <div className="mt-3">

                 </div>
                 <a
                 data-aos="flip-up"
                 data-aos-duration="800"
                   key={item.name}
                   href={item.path}
                   className={'fontShow1'}
                   aria-current={item.current ? "page" : undefined}
                 >
                   {item.name}
                 </a>
                
               
                 </>
              ))}
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
